export const enum ImportTemplateType {
  TEMPLATE_SUPPLIER_SERVICE_CATALOG = "TEMPLATE_SUPPLIER_SERVICE_CATALOG",
  TEMPLATE_CUSTOMER_SERVICE_CATALOG = "TEMPLATE_CUSTOMER_SERVICE_CATALOG",
  TEMPLATE_ACTIVITY_CUSTOMER_CATALOG = "TEMPLATE_ACTIVITY_CUSTOMER_CATALOG",
  TEMPLATE_ORDER = "TEMPLATE_ORDER",
}
